import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";
import { Input as SharedInput } from "../../components/IOSCompatibleInput/IOSCompatibleInput.style";

export const PageWrapper = styled.div<{ bottomOffset?: number }>`
  /* bottomOffset приходит от Telegram в физических пикселях. */
  min-height: calc(100vh + ${(props) => props.bottomOffset || 50}px);
  background:
    radial-gradient(
      51% 51% at 50% 121%,
      ${({ theme }) => theme.colors.brandLight},
      ${({ theme }) => theme.colors.brandTransparent}
    ),
    ${({ theme }) => theme.colors.canvas};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  width: 100%;
  padding-bottom: ${(props) => props.bottomOffset || 50}px;
`;

export const LidHeader = styled.h2`
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xxl)};
  font-weight: 700;
  margin: 0;
  margin-top: ${({ theme }) => pxToRem(theme.spacing.lg)};
`;

export const StepHeader = styled.div`
  width: 100%;
  max-width: ${pxToRem(560)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xxl)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};
  text-align: left;
`;

export const StepMeta = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  font-weight: 500;
  line-height: 1.4;
`;

export const FormTitle = styled.h2`
  color: ${({ theme }) => theme.colors.inkNearBlack};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
`;

export const StepDescription = styled.p`
  margin: ${({ theme }) => pxToRem(theme.spacing.sm)} 0 0;
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
`;

export const FormError = styled.div`
  width: 100%;
  max-width: ${pxToRem(560)};
  margin: ${({ theme }) => pxToRem(theme.spacing.md)} auto 0;
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};
  color: ${({ theme }) => theme.colors.dangerText};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.4;
  text-align: left;
`;

export const Input = styled(SharedInput)<{ hasError?: boolean }>`
  padding: 12px 16px;
  width: 100%;
  line-height: 1.25;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.inkBorder};
  background: ${({ theme }) => theme.colors.canvas};
  scrollbar-width: none;
  outline: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border-color: ${theme.colors.danger};
      background: ${theme.colors.brandMedium};
    `}

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => theme.colors.brandMedium};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.brand};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: 100%;
  max-width: ${pxToRem(560)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xl)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};

  input:not([type="checkbox"]) {
    min-height: 44px;
    padding: 12px 16px;
    line-height: 1.25;
    color: ${({ theme }) => theme.colors.ink};
  }

  input:not([type="checkbox"])::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  li {
    font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
    line-height: 1.25;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: 100%;
  max-width: ${pxToRem(560)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xl)};
  margin-bottom: ${pxToRem(50)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)};

  button {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    min-height: 44px;
    height: 44px;
    font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  }

  button:disabled {
    opacity: 0.5;
  }
`;
